<script setup lang="ts">
/*
import { ROUTES } from '@configs'
*/

/* const isFeed = computed(() => {
  const routeName = useGetRouteName()
  return routeName.includes(ROUTES.FEED.name)
}) */
import NovaMainTopBanner from '@components/NovaMainTopBanner/NovaMainTopBanner.vue'
</script>

<template>
  <NovaLayoutWrapper>
    <NovaHeader />
    <NovaLayoutMain :page-mode="true">
      <template #full-width-contents>
        <NovaMainTopBanner />
      </template>
      <template #default>
        <slot />
      </template>
    </NovaLayoutMain>
  </NovaLayoutWrapper>
</template>
